<template>
  <div
    class="pc-header-search-input"
  >
    <Language />
    <div
      class="category-tag"
      v-if="search.isTagActive.value"
    >
      {{ search.tagName }}
      <div
        class="category-tag__close"
        @click="search.isTagActive.value = false"
      >
        <Icon name="close-l-2" />
      </div>
    </div>
    <div class="septarator" />
    <input
      type="text"
      class="search-input-item"
      :placeholder="
        search.isTagActive.value
          ? 'Search within this category'
          : '🔍 Enter the description, and let’s find your treasure!'"
      @input="search.handleInputChange"
      v-model="search.inputValue.value"
      @keyup.enter="search.handleSubmit"
    >
    <Popover
      placement="bottom"
      trigger="click"
      class="search-camera"
    >
      <template #reference>
        <img
          src="@/assets/images/camera.svg"
          alt=""
        >
      </template>
      <SearchImg />
    </Popover>
    <div
      class="search-btn"
      @click="search.handleSubmit"
    >
      <img
        src="https://cdn-image.bestdealer.com/app-bestdealer/1688/search-icon.svg"
        alt=""
      >
    </div>
  </div>
</template>

<script setup>
import Popover from '@/components/Popover/index.vue'
import SearchImg from '../SearchImg/index.vue'
import Language from '../Language/index.vue'
import { Icon } from '../../Icon'
import { useSearch } from './useSearch'

const search = useSearch()
</script>

<style lang="less" scoped>
.pc-header-search-input {
  flex: 1;
  position: relative;
  margin-right: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  box-sizing: border-box;
  padding-right: 106px;
  padding-left: 88px;
  border-radius: 20px;
  background-color: #FFFFFF;

  .septarator {
    position: absolute;
    top: 50%;
    left: 80px;
    transform: translateY(-50%);
    height: 12px;
    width: 1px;
    background-color: #ebf1f5;
  }

  .category-tag {
    flex-shrink: 0;
    position: relative;
    padding: 5px 26px 5px 8px;
    background-color: #F8F8F8;
    border-radius: 14px;
    font-family: mon-500;
    font-size: 11px;
    line-height: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 179px;

    &__close {
      position: absolute;
      top: 5px;
      right: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background-color: #EBEBEB;
      font-size: 6px;
      cursor: pointer;
    }
  }

  .search-camera {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 64px;
    width: 26px;
    height: 26px;
    z-index: 101;

    img {
      cursor: pointer;
      width: 100%;
    }
  }

  .search-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 4px;
    width: 48px;
    height: 32px;
    background-color: #f57231;
    border-radius: 16px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .search-input-item {
    min-width: 120px;
    width: 100%;
    height: 100%;
    font-size: 14px;
    border: none;
    outline: none;
    font-family: mon-500;

    &:hover {
      outline: none;
    }

    &::placeholder {
      color: #B2B7C2;
    }
  }

  input::placeholder {
    font-size: 12px;
    font-family: mon-500;
    line-height: 16px;
    color: #6e717a;
  }
}
</style>
